// extracted by mini-css-extract-plugin
module.exports = {"printOnly":"Print_printOnly__AN1XW","noPrint":"Print_noPrint__29QhO"};